<template>
  <div>
    <div class="router-header flex flex-wrap items-center mb-3">
      <div class="content-area__heading pr-4">
      </div>
    </div>
    <div class="vx-row">
      <div
        v-for="comp in completed"
        :key="comp.id"
        class="vx-col w-full"
      >
        <a :href="constants.url + '/user/skill-details/' + comp.i" target="_blank">
          <div class="vx-card overflow-hidden mb-2">
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div>
                <!-- ADDED: justify-start and text-left here -->
                <div class="p-4 flex items-center justify-start text-left">
                  <span
                    class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                    style="background: rgba(var(--vs-primary),0.15);"
                  >
                    <img :src="comp.icon" alt="" width="40px" height="40px" />
                  </span>
                  
                  <!-- ADDED: ml-4 to give space from the icon, and text-left -->
                  <div class="truncate ml-4 flex-grow text-left">
                    <h5 class="mb-0 text-left font-semibold">{{ comp.comp }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import ccd from "@/assets/data/charactersistic-competency-definition";
import constants from "../../../../constants.js";

// Store Module
// import moduleAddSkill from "@/store/add-skill/moduleCompetencyProgress.js";

export default {
  name: "MySkills",
  props: ['completed'],
  data() {
    return {
      allCompetencies: [],
      CCD: this.$t("addNewSkill.data"),
      constants
    };
  },
  created() {},
  methods: {
    getSkillDetailsUrl(competencyId) {
    let url = `${this.constants.url}/user/skill-details/${competencyId}`;
    if (this.traineeName) {
      url += `?traineeName=${encodeURIComponent(this.traineeName)}&mentorView=true`;
    }
    return url;
  }
  },
  mounted() {}
};
</script>

<style scoped>
.vx-card {
  cursor: pointer;
}

.vx-card:hover {
  background: #F9F9F9;
}

.competency-img {
  width: 30px;
  height: 30px;
  margin: auto;
}

.selectedCompetency {
  background: #9dcd5b! important;
  color: white! important;
}

.selected-competency .competency-title h4 {
  color: white;
}

.not-selected-competency {
}

/*.con-vs-card {
      margin-bottom: 0.4rem;
      !*-webkit-box-shadow: none;
        box-shadow: none;*!
      min-height: 79px;
    }*/

.con-vs-card >>> .vs-card--content {
  padding: 3px 8px 3px 8px !important;
  margin-bottom: 10px;
}

.truncate {
  white-space: normal !important;
}

.truncate h5 {
  margin-left: 0 !important; /* Changed this from 0.5rem */
}

.truncate span {
  display: none;
}

.selectedCompetency >>> span.mc-icon {
  background: #fff !important;
}

.selectedCompetency .truncate span {
  display: block !important;
}

.selectedCompetency .truncate h5 {
  color: white;
}
</style>
